<template>
  <div class="track-detail">
    <div class="page-header">
      <i class="iconfont icon-back" @click="goBack">&#xe615;</i>
      <div class="page-title">物流详情</div>
      <i class="iconfont"></i>
    </div>

    <!-- 售后状态 -->
    <div class="track-status">
      <div class="status">
        <span class="label">您的订单已发出</span>
      </div>
      <div class="description"></div>
    </div>

    <div class="list-title is-desktop">配送清单</div>

    <!-- 退货信息 -->
    <div class="track-list">
      <div class="track-title is-mobile">
        <div class="logisticCode">
          <span class=""
            >{{ trackInfo.shipper_code }}{{ trackInfo.logistic_code }}</span
          >
          <span class="iconfont-ot-website" @click="copyText(trackInfo.logistic_code)"
            >&#xe606;</span
          >
        </div>
      </div>

      <div class="track-content">
        <div class="content-title">
          <div class="left">商品</div>
          <div class="logisticCode is-desktop">
            <span class=""
              >{{ trackInfo.shipper_code }}: {{ trackInfo.logistic_code }}</span
            >
            <span class="iconfont-ot-website" @click="copyText(trackInfo.logistic_code)"
              >&#xe606;</span
            >
          </div>
        </div>

        <div class="content" v-if="trackInfo.goods">
          <div
            class="goods-items"
            v-for="(item, index) in trackInfo.goods"
            :key="index"
          >
            <OrderItem
              :item="item"
              :isShowProductStatusLabel="true"
              :isShowProductLabel="true"
              :order-status="trackInfo.status"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="have-track-info" v-if="trackInfo.express_info">
      <div class="express-content">
        <div class="full-line"></div>
        <div class="express-item">
          <div class="express-item-left"></div>
          <div class="express-item-right">
            <div class="right-message address-message">
              {{ receiveAddress }}
            </div>
          </div>
        </div>
        <div
          v-for="(item, index) in trackInfo.express_info"
          :key="index"
          class="express-info-item"
        >
          <div
            v-for="(subItem, index1) in item.subStatus"
            :key="index1"
            :class="[
              'express-item',
              index === 0 && index1 === 0 ? 'active-express-item' : '',
            ]"
          >
            <div class="express-item-left">
              <div class="absove-icon"></div>
              <div class="left-date">
                {{ subItem.AcceptTime.split(" ")[0] }}
              </div>
              <div class="left-time">
                {{ subItem.AcceptTime.split(" ")[1] }}
              </div>
            </div>
            <div class="express-item-right">
              <div class="right-message">
                {{ subItem.AcceptStation }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="no-track-info">暂无物流信息</div>
    </div>
  </div>
</template>

<script>
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";
import OrderItem from "@/components/orderItem.vue";
import { captureManualError } from "@/sentry/index";

export default {
  components: { OrderItem },

  data() {
    return {
      trackInfo: {},
    };
  },
  created() {
    if (this.$route.query.id) {
      this.getLogisticsInfo();
    }
  },
  methods: {
    getLogisticsInfo() {
      api[types.GET_LOGISTICS_INFO]({
        order_no: this.$route.query.id,
        logistic_code: this.$route.query.logistic_code,
      })
        .then((res) => {
          if (res?.code == 1) {
            this.trackInfo = res.data;
            return res;
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
          captureManualError(err);
        });
    },

    goBack() {
      this.$router.push({
        path: `/myaccount/orderdetail?id=${this.$route.query.id}`,
      });
    },
    goDetail(item) {
      if (!item?.goodsId || !item?.color?.id) {
        return;
      }
      if (Number(item.skc_status) === 0) {
        //skc下架
        return;
      }
      this.$router.push({ path: `/detail/${item.goodsId}-${item.color.id}` });
    },

    copyText(text) {
      utils.copyText(text);
    },
  },
  computed: {
    receiveAddress() {
      const address = this.trackInfo?.address || {};
      const {
        username = "",
        mobile = "",
        province = "",
        city = "",
        county = "",
        detail = "",
      } = address;

      return `${province} ${city} ${county} ${detail} ${username} ${mobile}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.track-detail {
  text-align: left;

  .is-mobile {
    display: none;
  }

  .page-header {
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e7e7e7;
    position: relative;

    .icon-back {
      color: #bcbcbc;
      line-height: 40px;
      width: 40px;
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;
    }

    .page-title {
      font-size: 13px;
      color: #333333;
      line-height: 40px;
      text-align: center;
    }
  }

  .left {
    display: flex;
    flex-direction: column;
  }

  .track-status {
    padding: 20px;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    gap: 20px;
    background: #fbfbfb;

    .status {
      display: flex;
      align-items: center;
      color: #7f0019;

      .iconfont {
        font-size: 35px;
        margin-right: 20px;
      }
      .label {
        font-size: 20px;
      }
    }
    .description {
      display: flex;
      align-items: center;
      color: #666666;
      font-size: 14px;
      flex: 0 1 80%;
    }
  }

  .iconfont-ot-website {
    cursor: pointer;
  }
  .icon-copy {
    margin-left: 4px;
  }

  .icon-hide {
    margin-left: 10px;
  }

  .track-list {
    padding: 30px 0;
  }

  .list-title {
    font-size: 18px;
    padding-top: 30px;
  }

  .track-list {
    color: #666;
    font-size: 14px;
    padding: 20px 0 30px;
    box-sizing: border-box;

    .track-title {
      font-size: 13px;
      color: #333;
      font-weight: 500;
      margin-bottom: 20px;
    }

    .track-content {
      border: none;

      .content-title {
        display: none;
      }

      .content {
        display: flex;
        flex-direction: column;
        gap: 14px;
        padding-left: 2px;
        padding-bottom: 30px;

        ::v-deep .goods-items-content {
          display: flex;
          box-sizing: border-box;
          padding: 0 30px;
          .goods-others {
            flex-direction: column;
            align-items: normal;
            width: 40%;
          }
        }
      }
    }
  }

  // 此段代码为jc代码
  .have-track-info {
    position: relative;
    padding-top: 20px;

    .express-content {
      position: relative;
      font-family: "FZLanTingHeiS-R-GB";
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      .full-line {
        width: 1px;
        height: calc(100% - 49px);
        background-color: #cccccc;
        box-sizing: border-box;
        position: absolute;
        left: 10%;
        bottom: 21px;

        &::before {
          content: "收";
          text-align: center;
          font-size: 10px;
          font-weight: 400;
          line-height: 18px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          border: 1px solid #fafafa;
          box-sizing: border-box;
          background-color: #212322;
          color: #f7f7f7;
          position: absolute;
          top: -20px;
          left: -10px;
        }
      }

      .active-express-item {
        opacity: 1 !important;

        .express-item-left {
          .absove-icon {
            background: #212322 !important;
          }
        }
      }

      .express-info-item {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      .express-item {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        height: fit-content;
        color: #212322;
        opacity: 0.6;

        &:last-child {
          margin-bottom: 0;
        }

        .express-item-left {
          font-family: "Zona Pro";
          position: relative;
          width: 10%;
          height: inherit;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-end;
          padding-right: 20px;

          .absove-icon {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: -4px;
            background: #b3b3b3;
            border: 1px solid #fafafa;
            box-sizing: border-box;
          }

          .left-date {
            font-size: 12px;
            margin-bottom: 2px;
          }

          .left-time {
            font-size: 12px;
          }
        }

        .express-item-right {
          font-family: "FZLanTingHeiS-R-GB";
          flex: 1;
          min-height: 32px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          box-sizing: border-box;
          padding-left: 20px;
          opacity: 1 !important;

          .right-title {
            font-size: 14px;
          }

          .right-message {
            font-size: 12px;
          }

          .address-message {
            font-family: "FZLanTingHeiS-R-GB";
            color: #212322;
            font-weight: 400;
          }
        }
      }
    }
  }
  .no-track-info {
      text-align: center;
      padding: 30px;
    }
}

@media only screen and (min-width: 1025px) {
  .track-detail {
    .page-header {
      display: none;
    }
    .track-list {
      color: #666;
      font-size: 14px;
      padding: 30px 0;
      box-sizing: border-box;

      .track-title {
        font-size: 18px;
        color: #333;
        font-weight: 500;
        margin-bottom: 20px;
      }

      .save-refund {
        margin-left: 100px;
      }

      .track-content {
        border: 1px solid #d2d2d2;

        .content-title {
          height: 40px;
          color: #333;
          font-size: 14px;
          line-height: 40px;
          border-bottom: 1px solid #d2d2d2;
          margin-bottom: 20px;
          padding-left: 30px;
          display: flex;
          justify-content: space-between;
          padding-right: 30px;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .track-detail {
    .bread-crumbs {
      display: none;
    }

    .page-header {
      display: block;
    }

    .list-title {
      font-size: 14px;
      padding-top: 20px;
    }

    .is-mobile {
      display: block;
    }

    .is-desktop{
      display: none;
    }

    .track-status {
      flex-direction: column;
      gap: 10px;

      .status {
        .iconfont {
          margin-right: 16px;
        }
        .label {
          font-size: 14px;
        }
      }
      .description {
        font-size: 12px;
      }
    }

    .icon-hide {
      float: right;
    }
    .content {
      border-bottom: 1px solid #d2d2d2;
    }

    ::v-deep .goods-items-content {
      display: flex;
      box-sizing: border-box;
      //   margin-bottom: 20px;
      padding: 0 !important;
      .goods-others {
        flex-direction: column;
        align-items: normal;
        width: 100% !important;
      }
    }
    .goods-items {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    // 此段代码为jc代码
    .have-track-info {
      .express-content {
        .full-line {
          left: 26%;
        }
        .express-item {
          .express-item-left {
            width: 26%;
          }
        }
      }
    }
    .no-track-info {
      text-align: center;
      padding: 30px;
    }
  }
}
</style>
